"use client";
import React from "react";

const CustomModal = ({ openModal, onClose, onSubmit }) => {
  return (
    <>
      {openModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/10 backdrop-blur-sm">
          <div className="w-full max-w-md bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl border border-gray-200 overflow-hidden">

            {/* Header */}
            <div className="px-6 py-4 bg-gradient-to-r from-red-500 to-red-600 text-white bg-black flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/20">
                ⚠️
              </div>
              <h2 className="text-lg font-semibold tracking-wide">
                Confirm Deletion
              </h2>
            </div>

            {/* Body */}
            <div className="px-6 py-5 text-gray-600 text-sm leading-relaxed">
              Are you sure you want to delete this item? This action cannot be undone.
            </div>

            {/* Footer */}
            <div className="flex justify-end gap-3 px-6 py-4 bg-gray-50 border-t">
              <button
                onClick={onClose}
                className="px-5 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 transition-all active:scale-95"
              >
                Cancel
              </button>

              <button
                onClick={onSubmit}
                className="px-5 py-2 text-sm font-medium text-white bg-black rounded-lg bg-gradient-to-r from-red-500 to-red-600 hover:opacity-90 transition-all active:scale-95 shadow-md"
              >
                Delete
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default CustomModal;
